module.exports = __webpack_public_path__ + "img/v3plus.32e4aa33.svg";